import React from 'react';
import { Paper, Typography } from '@material-ui/core';

import colors from '../../../theme/colors';

const TransferRedirectNotice = ({ show }) =>
  show ? (
    <Paper
      style={{
        padding: '12px 16px',
        marginBottom: 16,
        background: '#FFF8E1',
        borderLeft: `4px solid ${colors.warning || '#FFB300'}`
      }}
    >
      <Typography variant="body1">
        Redirected from a transferred debtor. You are now viewing the master
        debtor profile.
      </Typography>
    </Paper>
  ) : null;

export default TransferRedirectNotice;
